<template>
    <div class="blog" v-if="ready">
        <ListPosts :posts="posts"> </ListPosts>
        <!--
        <div v-if="ready && !loading && morePosts" v-observe-visibility="loadMore">&nbsp;</div>
        -->
        <div v-if="ready && !loading && morePosts" class="list__button">
            <a v-on:click="loadMore">Flere blogginnlegg</a>
        </div>
        <br />
        <br />
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import ListPosts from '@/components/ListPosts.vue';

export default {
    name: 'Blog',
    components: {
        ListPosts,
    },
    data: function () {
        return {
            ready: false,
            loading: false,
            morePosts: true,
        };
    },
    computed: mapState(['posts']),
    async created() {
        await this.loadPosts({ limit: 10 });
        this.ready = true;
    },
    methods: {
        ...mapActions(['loadPosts']),
        loadMore: async function (isVisible) {
            if (!this.loading && isVisible) {
                this.loading = true;
                const currentLength = this.posts.length;
                const offset = this.posts.length;
                await this.loadPosts({ limit: 10, offset: offset });

                this.loading = false;

                if (this.posts.length == currentLength) {
                    this.morePosts = false;
                }
            }
        },
    },
};
</script>
